export enum RepairResourceTypeEnum {
  'Bumper' = 'Bumper',
  'Hanger' = 'Hanger',
  'Finisher' = 'Finisher',
  'Sprayer' = 'Sprayer',
  'Specialist' = 'Specialist',
}
